import { createRouter, createWebHistory } from 'vue-router';
import { registerGuard } from './guard';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      alias: '/login',
      name: 'Login',
      component: () => import('@/components/LoginPage.vue'),
      meta: {
        title: 'Login',
        requiresAuth: false,
        requiresAdmin: false
      }
    },
    {
      path: '/register',
      name: 'Registration',
      component: () => import('@/components/LoginPage.vue'),
      meta: {
        title: 'Register',
        requiresAuth: false,
        requiresAdmin: false
      }
    },
    {
      path: '/reset-password',
      alias: '/reset',
      name: 'Reset password',
      component: () => import('@/components/LoginPage.vue'),
      meta: {
        title: 'Reset password',
        requiresAuth: false,
        requiresAdmin: false
      }
    },
    {
      path: '/set-password',
      alias: '/set',
      name: 'Set password',
      component: () => import('@/components/LoginPage.vue'),
      meta: {
        title: 'Set password',
        requiresAuth: false,
        requiresAdmin: false
      }
    },
    {
      path: '/welcome',
      name: 'AppLayout',
      component: () => import('@/components/AppLayout.vue'),
      meta: {
        title: 'Identity Governor',
        requiresAuth: true,
        requiresAdmin: false
      },
      children: [
        {
          path: '/sso',
          name: 'SSO',
          components: {
            page: () => import('@/components/SingleSignOnPage.vue')
          },
          meta: {
            title: 'Single Sign-On',
            requiresAuth: true,
            requiresAdmin: true
          }
        }
      ]
    },
    {
      path: '/device-authorize',
      name: 'DeviceAuthorization',
      component: () => import('@/components/DeviceAuthorizationPage.vue'),
      meta: {
        title: 'Device Authorization',
        requiresAuth: false,
        requiresAdmin: false,
        skipAuthRedirect: true
      }
    },
    {
      path: '/ssotest',
      name: 'Claims',
      component: () => import('@/components/ClaimsPage.vue'),
      meta: {
        title: 'Test user claims',
        requiresAuth: true,
        requiresAdmin: false
      }
    }
  ]
});

router.afterEach((to) => {
  if (typeof to.meta.title === 'string') {
    document.title = `${to.meta.title} | SkillsTown`;
  }
});

registerGuard(router);
